import { useMemo } from 'react';
import { Provider } from 'react-redux';

import { createReduxStore } from './config';
import { StoreProviderProps } from './StoreProvider.types';
import { initialState } from './StoreProvider.constants';

export const StoreProvider = (props: StoreProviderProps) => {
    const { children, store: externalStore } = props;

    const store = useMemo(() => externalStore ?? createReduxStore(initialState), [externalStore]);

    return <Provider store={store}>{children}</Provider>;
};
